import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  keys: [],
  key: null
}

// mutations
export const mutations = {
  [types.SET_KEYS] (state, keys) {
    state.keys = keys
  },
  [types.SET_KEY] (state, key) {
    state.key = key
  }
}

// actions
export const actions = {
  async fetchKeys ({ commit }, payload) {
    try {
      const { data } = await axios.get(`/api/applications`)
      commit(types.SET_KEYS, data)
    } catch (e) {
      console.log(e)
    }
  },

  async createKey (context, key) {
    try {
      await axios.post('/api/applications', key)
      context.dispatch('fetchKeys')
    } catch (e) {
      console.log(e)
    }
  },

  async deleteKey (context, keyId) {
    try {
      await axios.delete(`/api/applications/${keyId}`)
      context.dispatch('fetchKeys')
    } catch (e) { }
  }
}

// getters
export const getters = {
  keys: state => state.keys,
  key: state => state.key
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/key.js